(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* =================================================
     STICKY HEADER — SCROLL-ACTIVE SHADOW TRIGGER
     Added: Sep 2026, per Eli's follow-up request
     Eli wanted the shadow (defined in book-tattoo-hover.css)
     present only while actively scrolling, fading out again a
     moment after scrolling stops — rather than staying on for
     the whole time the header is pinned/floating, which is what
     the existing scrolled-past-header class alone gives (it only
     toggles off back at the very top of the page).
     Adds a second class, header-scroll-shadow, purely on/off with
     scroll activity: added on every scroll event, removed again
     after a brief idle period (200ms with no further scroll
     events — long enough to smooth over the small gaps between
     individual wheel/trackpad ticks during one continuous scroll
     gesture, short enough to feel prompt once scrolling genuinely
     stops). The CSS only shows the shadow when BOTH this class and
     scrolled-past-header are present together, so it still never
     appears at the very top of the page before the header is
     actually floating over anything.
     ================================================= */
  (function () {
    var header = document.querySelector('.section-header');
    if (!header) return;

    var SCROLL_IDLE_MS = 200;
    var scrollShadowTimer = null;

    window.addEventListener(
      'scroll',
      function () {
        header.classList.add('header-scroll-shadow');
        window.clearTimeout(scrollShadowTimer);
        scrollShadowTimer = setTimeout(function () {
          header.classList.remove('header-scroll-shadow');
        }, SCROLL_IDLE_MS);
      },
      { passive: true }
    );
  })();

  /* =================================================
     BOOK TATTOO CTA — THE ATTENTION GESTURE
     Added Sep 2026; rebuilt Sep 2026 (Eli) so the schedule is
     set in the theme editor instead of in code.

     WHAT IT DOES: adds the .heartbeat class to the header's Book
     Tattoo button now and then. The gesture itself — a two-beat
     swell with a gentle wobble threaded through it — lives in
     assets/book-tattoo-hover.css, which is also where its look
     should be retuned. This script only decides WHEN.

     WHEN: five timings, set in this section's own settings
     (Header > Book Tattoo CTA animation) and handed over on the
     button as data-cta-schedule, in seconds:
       1st  from the moment the button is first actually seen
       2nd  after the 1st gesture finishes
       3rd  after the 2nd finishes
       4th  after the 3rd finishes
       then the repeat interval, over and over
     A delay of 0 stops the sequence there. The defaults (3, 7,
     12, 12, 12) reproduce the rhythm the page had before these
     settings existed: roughly 3s, 11s, 24s, 37s, 50s ...

     The clock starts on first sight rather than on page load,
     which for a header button is usually the same instant — but
     not, say, when the page opens scrolled down. Once started it
     simply runs; it doesn't restart every time the button
     scrolls in and out of view.

     It never interrupts: a gesture due while the button is
     hovered, focused, being pressed, or while the tab is in the
     background is skipped rather than saved up, so nothing fires
     in a burst when someone comes back. It never runs on the
     Book page (the button is greyed out and inert there), never
     under prefers-reduced-motion, and never on the copy of this
     link inside the mobile menu drawer — only the header's own
     button is selected below.
     ================================================= */
  (function () {
    var bookButton = document.querySelector('.header__icons .header-book-tattoo');
    if (!bookButton || document.body.classList.contains('page-book')) return;

    // Used only if the settings somehow don't arrive; same as the schema defaults
    var FALLBACK_SCHEDULE = [3, 7, 12, 12, 12];

    var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var timer = null;
    var played = 0; // gestures due so far (played or skipped)
    var gestureLengthMs = 1100; // re-read from the CSS whenever one plays

    var schedule = (bookButton.getAttribute('data-cta-schedule') || '').split(',').map(function (value) {
      return parseFloat(value) * 1000;
    });
    var usable =
      schedule.length === FALLBACK_SCHEDULE.length &&
      schedule.every(function (value) {
        return !isNaN(value) && value >= 0;
      });
    if (!usable) {
      schedule = FALLBACK_SCHEDULE.map(function (seconds) {
        return seconds * 1000;
      });
    }

    // The wait before gesture number n (0 = the first one); after the fourth,
    // the last value (the repeat interval) is used for ever.
    function gapBefore(gestureNumber) {
      return schedule[Math.min(gestureNumber, schedule.length - 1)];
    }

    // How long the gesture lasts, read from the live animation-duration
    // of .heartbeat, so retuning the CSS keeps these gaps correct.
    function readGestureLength() {
      var duration = window.getComputedStyle(bookButton).animationDuration.split(',')[0].trim();
      var value = parseFloat(duration);
      if (isNaN(value) || value <= 0) return gestureLengthMs;
      return /ms$/.test(duration) ? value : value * 1000;
    }

    // Leave the person alone: pointer on it, keyboard on it, being pressed,
    // or the tab isn't even on screen.
    function shouldSkip() {
      if (document.hidden || reducedMotionQuery.matches) return true;
      try {
        return bookButton.matches(':hover, :active, :focus');
      } catch (error) {
        return false;
      }
    }

    function playGesture() {
      if (shouldSkip()) return;
      // Remove-then-reflow-then-add so it restarts cleanly even if a
      // previous gesture is somehow still mid-flight.
      bookButton.classList.remove('heartbeat');
      void bookButton.offsetWidth;
      bookButton.classList.add('heartbeat');
      gestureLengthMs = readGestureLength();
    }

    function scheduleNext(waitMs) {
      clearTimeout(timer);
      if (!(waitMs > 0)) return; // 0 = stop here
      timer = setTimeout(function () {
        playGesture();
        played += 1;
        // Each gap is measured from when the gesture finishes (or would have,
        // if it was skipped), so the rhythm carries on unchanged either way.
        scheduleNext(gestureLengthMs + gapBefore(played));
      }, waitMs);
    }

    function start() {
      clearTimeout(timer);
      played = 0;
      if (reducedMotionQuery.matches) return;
      scheduleNext(gapBefore(0));
    }

    function stop() {
      clearTimeout(timer);
      timer = null;
      bookButton.classList.remove('heartbeat');
    }

    bookButton.addEventListener('animationend', function (event) {
      if (event.animationName === 'book-heartbeat') {
        bookButton.classList.remove('heartbeat');
      }
    });

    // Someone reaching for it mid-gesture: let it go immediately, so the
    // automatic motion never fights the hover state.
    ['mouseenter', 'focus', 'pointerdown'].forEach(function (name) {
      bookButton.addEventListener(name, function () {
        bookButton.classList.remove('heartbeat');
      });
    });

    reducedMotionQuery.addEventListener('change', function () {
      if (reducedMotionQuery.matches) {
        stop();
      } else {
        scheduleNext(gapBefore(played)); // rejoin the rhythm where it left off
      }
    });

    // Start the clock the first time the button is genuinely on screen.
    if ('IntersectionObserver' in window) {
      var watcher = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        watcher.disconnect(); // first sighting only; it never restarts
        start();
      });
      watcher.observe(bookButton);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
